<template lang="pug">
.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/ticket")
          i.fa.fa-credit-card
          span.ml-1 {{ $t("title.ticket") }}
      b-breadcrumb-item
        router-link(to="/ticket/pendingTicket")
          i.fa.fa-list
          span.ml-1 {{ $t("ui.pending_ticket") }}

  .row
    .col-md-12
      .form-row
        .col-xs-10.col-sm-6.col-md-4.col-lg-4.mb-1
          b-input-group(size="sm")
            b-input-group-text(slot="prepend")
              i.icon-user
            DebounceInput(
              type="search"
              v-model.trim.lazy="search_id"
              :placeholder="$t('ui.account_id')"
            )
        .col-xs-10.col-sm-6.col-md-4.col-lg-4.mb-1
          b-input-group(size="sm")
            b-input-group-text(slot="prepend").p-1
              .d-flex.align-items-center.justify-content-center
                label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                  input.switch-input(type="checkbox" v-model="refreshOn" @change="toggleRefresh()")
                  span.switch-slider(data-checked='on' :data-unchecked='off')
            b-input(v-model="refreshInterval" type="range" min="1" max="10")
            b-input-group-text(slot="append")
              div(style="text-transform: none;") {{ timer }}&nbsp;/&nbsp;
              div(style="text-transform: none;") {{ refreshInterval }}s
        .col-xs-10.col-sm-6.col-md-2.col-lg-2.mb-1
          b-input-group(size="sm")
            b-input-group-text(slot="prepend")
              span.text-uppercase {{ $t('ui.alert') }}
            b-input-group-text(slot="append").p-1
              div.d-flex.justify-content-center.align-items-center
                //- span {{ alert }}
                label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                  input.switch-input(type="checkbox" :checked="alert" @input="dispatchAlert($event.target.value)")
                  span.switch-slider(:data-checked='on' :data-unchecked='off')
        .col-xs-2.col-sm-2.col-md-2.col-lg-2.mb-1.text-right
          SubmitButton.mr-1(
            icon="fa fa-retweet"
            :text="$t('ui.refresh')"
            type="button"
            @click="refresh"
            variant="info"
            size="sm"
          )
          SubmitButton(
            icon="fa fa-search"
            :text="$t('ui.search')"
            type="button"
            @click="submit"
            variant="success"
            size="sm"
          )

  .row
    .col-md-12
      b-tabs(small card)
        //- DEPOSIT
        b-tab(title-link-class="small-link" title-item-class="small-item")
          template(slot="title")
            span(style="padding: 1px; line-height: 16px;") {{ $t("ui.deposit") }}
            b-badge(
              variant="tab"
              size="sm"
              :class="{ 'badge-danger' : deposit.totalRows > 0 }"
              ).ml-1 {{ deposit.totalRows }}
          b-row
            .col-md-10.d-flex.align-items-center.justify-content-start.text-center
              b-pagination.float-left(
                size="sm"
                hide-ellipsis
                :total-rows="deposit.totalRows"
                :per-page="perPage"
                v-model="deposit.currentPage"
                @input="depositChangedPage($event)").mb-1
              .d-flex.align-items-center.justify-content-start.text-center.px-1.mb-1.pl-2
                i.fa.fa-spin.fa-spinner(v-if="deposit.loading")
            .col-md-2
              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
          b-row
            .col-sm-12.col-md-12.col-lg-12.col-xl-12

              b-table#depositList.table-sm.table-hover(
                show-empty
                :empty-text="$t('message.no_records')"
                :no-local-sorting="true"
                responsive
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :items="deposit.list"
                :fields="fields"
                :per-page="perPage"
                @sort-changed="sortingChanged"
                )
                template(v-slot:cell(created_date)="row")
                  .d-block.text-primary(style="line-height: 1;") {{ $moment(row.item.created_date).format('DD/MM/YYYY') }}
                  .d-block.text-zero(style="line-height: 1;") {{ $moment(row.item.created_date).format('HH:mm:ss A') }}
                template(v-slot:cell(account_id)="row")
                  .text-left
                    span #[b {{ row.item.account_id }}]
                template(v-slot:cell(status)="row")
                  .text-center.text-uppercase.text-danger.thin-text(
                    v-if="row.item.status.toUpperCase() == 'REJECTED'"
                    ) {{ row.item.status }}
                  .text-center.text-uppercase.thin-text(v-else) {{ row.item.status }}
                template(v-slot:cell(request_type)="row")
                  .d-block.text-left.thin-text {{ row.item.account_type }}
                  .d-block.text-left.thin-text {{ row.item.request_type }}
                template(v-slot:cell(amount)="row")
                  .text-right
                    span(
                      :class="$helpers.getNumberClass(row.item.amount)"
                      )
                      | #[b {{ row.item.amount | currency }}]
                template(v-slot:cell(action)="row")
                  .d-flex.align-items-center.justify-content-start
                    b-link.action-item.fa.fa-paperclip.text-primary(
                      href="javascript:;"
                      :title="$t('ui.attachment')"
                      @click="openLink(row.item.attachment_path)"
                      :disabled="row.item.attachment_path == null"
                      )
                    b-link.action-item.fa.fa-check.text-primary.action-secondary(
                      href="javascript:;"
                      :title="$t('ui.approve')"
                      @click="updateDepositTicket(row.item, true)"
                      :disabled="row.item.status.toUpperCase() != 'PENDING'"
                      )
                    b-link.action-item.fa.fa-times.text-primary.action-secondary(
                      href="javascript:;"
                      :title="$t('ui.reject')"
                      @click="updateDepositTicket(row.item, false)"
                      :disabled="row.item.status.toUpperCase() != 'PENDING'"
                      )
                template(v-slot:cell(bank_id)="row")
                  .d-flex.align-items-center.justify-content-start.flex-column
                    b-button.btn-collapse(size="sm" block v-b-toggle="'collapse-' + row.item.id" variant="link")
                      .d-flex.align-items-center.justify-content-start
                        i.fa.fa-chevron-down(aria-hidden="true")
                        .text-left {{ row.item.bank_id }}
                          span(v-if="row.item.ref_no") @ #[b {{ row.item.ref_no }} ]
                    b-collapse(
                      :id="'collapse-' + row.item.id"
                      accordion="accordion-deposit"
                      )
                      .table-responsive.mb-0
                        table.table.table-sm.table-b-0
                          tbody
                            tr
                              td.text-tiny(style="width: 24px;")
                                i.fa.fa-university.text-zero
                              td.text-tiny
                                span {{ row.item.bank_acc_holder }} @ #[b {{ row.item.bank_acc_no }}]
                            tr
                              td.text-tiny
                                i.fa.fa-user.text-zero
                              td.text-tiny
                                span {{ row.item.modified_by }}
                                  template(v-if="row.item.modified_date") &nbsp;[{{ $moment(row.item.modified_date).format("YYYY-M-DD HH:mm:ss") }}]
                            tr
                              td.text-tiny
                                i.fa.fa-location-arrow.text-zero
                              td.text-tiny
                                span {{ row.item.client_ip }}
                            tr
                              td.text-tiny
                                i.fa.fa-credit-card.text-zero
                              td.text-tiny
                                span {{ row.item.deposit_method }}
                                  template(v-if="row.item.deposit_date") &nbsp;[{{ $moment(row.item.deposit_date).format("YYYY-M-DD") }}]
                            tr
                              td.text-tiny
                                i.fa.fa-comment.text-zero
                              td.text-tiny
                                span {{ row.item.remark }}
                template(v-slot:cell(redeposit)="row")
                  //-
                  .d-flex.align-items-center.justify-content-start
                    .d-flex.flex-fill.py-0
                      span(v-if="row.item.redeposit_ticket_id") {{ $t('ui.id') }}: #[b {{ row.item.redeposit_ticket_id }} ]
                    .d-flex.align-items-center.justify-content-center.py-0(v-if="row.item.redeposit" style="width: 13px;")
                      i.fa.fa-check.text-success

        //- WITHDRAWAL
        b-tab(title-link-class="small-link" title-item-class="small-item")
          template(slot="title")
            span(style="padding: 1px; line-height: 16px;") {{ $t("ui.withdrawal") }}
            b-badge(
              variant="tab"
              size="sm"
              ).ml-1 {{ withdrawal.totalRows }}
          b-row
            .col-md-10.d-flex.align-items-center.justify-content-start.text-center
              b-pagination.float-left(
                size="sm"
                hide-ellipsis
                :total-rows="withdrawal.totalRows"
                :per-page="perPage"
                v-model="withdrawal.currentPage"
                @input="withdrawalChangedPage($event)").mb-1
              .d-flex.align-items-center.justify-content-start.text-center.px-1.mb-1.pl-2
                i.fa.fa-spin.fa-spinner(v-if="withdrawal.loading")
            .col-md-2
              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")

          b-row
            .col-sm-12.col-md-12.col-lg-12.col-xl-12

              b-table#withdrawalList.table-sm.table-hover(
                show-empty
                :empty-text="$t('message.no_records')"
                :no-local-sorting="true"
                responsive
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :items="withdrawal.list"
                :fields="fields"
                :per-page="perPage"
                @sort-changed="sortingChanged"
                )
                template(v-slot:cell(created_date)="row")
                  .d-block.text-primary(style="line-height: 1;") {{ $moment(row.item.created_date).format('DD/MM/YYYY') }}
                  .d-block.text-zero(style="line-height: 1;") {{ $moment(row.item.created_date).format('HH:mm:ss A') }}
                template(v-slot:cell(account_id)="row")
                  .text-left #[b {{ row.item.account_id }}]
                template(v-slot:cell(status)="row")
                  .text-center.text-uppercase.text-danger.thin-text(
                    v-if="row.item.status.toUpperCase() == 'REJECTED'"
                    ) {{ row.item.status }}
                  .text-center.text-uppercase.thin-text(v-else) {{ row.item.status }}
                template(v-slot:cell(request_type)="row")
                  .d-block.text-left.thin-text {{ row.item.account_type }}
                  .d-block.text-left.thin-text {{ row.item.request_type }}
                template(v-slot:cell(amount)="row")
                  .text-right
                    span(
                      :class="$helpers.getNumberClass(row.item.amount)"
                      )
                      | #[b {{ row.item.amount | currency }}]
                template(v-slot:cell(action)="row")
                  .d-flex.align-items-center.justify-content-start
                    b-link.action-item.fa.fa-paperclip.text-primary(
                      href="javascript:;"
                      :title="$t('ui.attachment')"
                      @click="openLink(row.item.attachment_path)"
                      :disabled="row.item.attachment_path == null"
                      )
                    b-link.action-item.fa.fa-check.text-primary.action-secondary(
                      href="javascript:;"
                      :title="$t('ui.approve')"
                      @click="updateWithdrawalTicket(row.item, true)"
                      :disabled="row.item.status.toUpperCase() != 'PENDING'"
                      )
                    b-link.action-item.fa.fa-times.text-primary.action-secondary(
                      href="javascript:;"
                      :title="$t('ui.reject')"
                      @click="updateWithdrawalTicket(row.item, false)"
                      :disabled="row.item.status.toUpperCase() != 'PENDING'"
                      )
                template(v-slot:cell(bank_id)="row")
                  .d-flex.align-items-center.justify-content-start.flex-column
                    b-button.btn-collapse(size="sm" block v-b-toggle="'collapse-' + row.item.id" variant="link")
                      .d-flex.align-items-center.justify-content-start
                        i.fa.fa-chevron-down(aria-hidden="true")
                        .text-left {{ row.item.bank_id }}
                          span(v-if="row.item.ref_no") @ #[b {{ row.item.ref_no }})]
                    b-collapse(
                      :id="'collapse-' + row.item.id"
                      accordion="accordion-withdrawal"
                      )
                      .table-responsive.mb-0
                        table.table.table-sm.table-b-0
                          tbody
                            tr
                              td.text-tiny(style="width: 24px;")
                                i.fa.fa-university.text-zero
                              td.text-tiny
                                span {{ row.item.bank_acc_holder }} @ #[b {{ row.item.bank_acc_no }}]
                            tr
                              td.text-tiny
                                i.fa.fa-user.text-zero
                              td.text-tiny
                                span {{ row.item.modified_by }}
                                  template(v-if="row.item.modified_date") &nbsp;[{{ $moment(row.item.modified_date).format("YYYY-M-DD HH:mm:ss") }}]
                            tr
                              td.text-tiny
                                i.fa.fa-location-arrow.text-zero
                              td.text-tiny
                                span {{ row.item.client_ip }}
                            tr
                              td.text-tiny
                                i.fa.fa-credit-card.text-zero
                              td.text-tiny
                                span {{ row.item.deposit_method }}
                                  template(v-if="row.item.deposit_date") &nbsp;[{{ $moment(row.item.deposit_date).format("YYYY-M-DD") }}]
                            tr
                              td.text-tiny
                                i.fa.fa-comment.text-zero
                              td.text-tiny
                                span {{ row.item.remark }}
                template(v-slot:cell(redeposit)="row")
                  //-
                  .d-flex.align-items-center.justify-content-start
                    .d-flex.flex-fill.py-0
                      span(v-if="row.item.redeposit_ticket_id") {{ $t('ui.id') }}: #[b {{ row.item.redeposit_ticket_id }} ]
                    .d-flex.align-items-center.justify-content-center.py-0(v-if="row.item.redeposit" style="width: 13px;")
                      i.fa.fa-check.text-success

  depositTicket(ref="depositTicket" @done="submit")
  withdrawalTicket(ref="withdrawalTicket" @done="submit")

  #end-report.mt-3
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, email, sameAs, numeric, decimal, helpers } from "vuelidate/lib/validators";

import config from "@/config";
import errorTags from "@/errorTags";

import DateRangePicker from "@/library/DateRangePicker.vue";
import DebounceInput from "@/library/DebounceInput";
import ValidateResult from "@/library/ValidateResult";
import SubmitButton from "@/library/SubmitButton.vue";
import currency from "@/components/currency.vue";

import depositTicket from "@/components/ticket/depositTicket.vue";
import withdrawalTicket from "@/components/ticket/withdrawalTicket.vue";

import xhr from "@/plugins/xhr.js";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ValidateResult,
    DateRangePicker,
    currency,
    depositTicket,
    withdrawalTicket
  },
  data() {
    return {
      timer: 0,
      search_id: "",
      ticket_status: "PENDING",
      bank_id: "",
      bankList: [],
      depositBankList: [],
      withdrawalBankList: [],
      withdrawal: {
        list: [],
        currentPage: 1,
        totalRows: 0,
        loading: false
      },
      deposit: {
        list: [],
        currentPage: 1,
        totalRows: 0,
        loading: false
      },
      account_id: "",
      sortBy: "id",
      sortDesc: false,
      ticketTimer: null,
      refreshOn: true,
      refreshInterval: 5,
      refreshChange: ""
    };
  },
  validations: {},
  computed: {
    alert() {
      return this.$store.getters.alert;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    fields() {
      return [
        {
          key: "id",
          label: "#",
          class: "text-center",
          thStyle: {
            width: "50px"
          }
        },
        {
          key: "created_date",
          label: this.$t("ui.date"),
          sortable: false,
          thStyle: {
            width: "90px"
          }
        },
        {
          key: "account_id",
          label: this.$t("ui.account_id"),
          sortable: false,
          thStyle: {
            width: "160px"
          }
        },
        // {
        //   key: "status",
        //   label: this.$t("ui.status"),
        //   class: "text-center",
        //   thStyle: {
        //     width: "80px"
        //   }
        // },
        {
          key: "request_type",
          label: this.$t("ui.type"),
          class: "text-left",
          thStyle: {
            width: "90px"
          }
        },
        {
          key: "amount",
          label: this.$t("ui.amount"),
          class: "text-right",
          thStyle: {
            width: "160px"
          }
        },
        {
          key: "action",
          label: this.$t("ui.action"),
          thStyle: {
            width: "83px"
          }
        },
        {
          key: "bank_id",
          label: this.$t("ui.info"),
          class: "text-left"
        },
        {
          key: "redeposit",
          label: this.$t("ui.redeposit"),
          class: "text-left",
          thStyle: {
            width: "90px"
          }
        }
      ];
    },
    perPage() {
      return this.$store.getters.pageSize;
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC";
    },
    dateRange() {
      return [this.$moment(this.$store.getters.dateRange[0]), this.$moment(this.$store.getters.dateRange[1])];
    }
  },
  destroyed() {
    this.clearRefreshTimer();
  },
  mounted() {
    this.submit();
    this.startRefreshTimer();
  },
  methods: {
    dispatchAlert(e) {
      console.log(e);
      this.$store.dispatch("layout/setAlert", !this.alert);
    },
    toggleRefresh() {
      this.startRefreshTimer();
    },
    clearRefreshTimer() {
      if (this.ticketTimer) {
        clearTimeout(this.ticketTimer);
      }
    },
    startRefreshTimer() {
      if (this.timer >= this.refreshInterval) {
        this.timer = 0;
        if (this.refreshOn) {
          // this.getTicketList();
          this.getList();
          this.clearRefreshTimer();
          this.ticketTimer = setTimeout(() => {
            this.startRefreshTimer();
          }, 1000);
        } else {
          this.clearRefreshTimer();
        }
      } else {
        this.timer += 1;
        this.ticketTimer = setTimeout(() => {
          this.startRefreshTimer();
        }, 1000);
      }
    },
    depositChangedPage(e) {
      this.deposit.currentPage = e;
      this.getDepositList();
    },
    withdrawalChangedPage(e) {
      this.withdrawal.currentPage = e;
      this.getWithdrawalList();
    },
    changedPageSize(e) {
      this.$store.dispatch("layout/setPageSize", e);
      this.deposit.currentPage = 1;
      this.withdrawal.currentPage = 1;
      this.submit();
    },
    sortingChanged(e) {
      if (e.sortBy !== this.sortBy) {
        this.sortDesc = false;
      } else {
        this.sortDesc = this.direction === "ASC";
      }

      this.sortBy = e.sortBy;
      this.submit();
    },
    submit() {
      this.getBankList();
      this.getWithdrawalBankList();
      // this.getTicketList();
      this.getList();
    },
    refresh() {
      this.search_id = "";
      this.getBankList();
      // this.getTicketList();
      this.getList();
    },
    getList() {
      this.getDepositList();
      this.getWithdrawalList();
    },
    getBankList() {
      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username
      };
      xhr
        .doRequest(args, xhr.ACCOUNT.bankLookup)
        .then(res => {
          this.bankList = res.data.bank_lookup;
        })
        .catch(res => {
          this.$helpers.handleFeedback(res.status);
        });
    },
    getDepositBankList() {
      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username
      };
      xhr
        .doRequest(args, xhr.ACCOUNT.depositBankList)
        .then(res => {
          this.depositBankList = res.data.bank_list;
        })
        .catch(res => {
          this.$helpers.handleFeedback(res.status);
        });
    },
    getWithdrawalBankList() {
      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username
      };
      xhr
        .doRequest(args, xhr.ACCOUNT.withdrawalBankList)
        .then(res => {
          this.withdrawalBankList = res.data.bank_list;
        })
        .catch(res => {
          this.$helpers.handleFeedback(res.status);
        });
    },
    // getTicketList() {
    //   var args = {
    //     session_token: this.$store.getters.sessionToken,
    //     action_by: this.$store.getters.username
    //   };
    //   args["request_type"] = "deposit";
    //   args["page_number"] = parseInt(this.deposit.currentPage);
    //   this.deposit.currentPage = args["page_number"];

    //   args["bank_id"] = this.bank_id || null;
    //   args["member_id"] = this.search_id || null;
    //   args["ticket_status"] = this.ticket_status || null;
    //   args["page_size"] = this.perPage;
    //   args["sort_key"] = "id"; // this.sortBy;
    //   args["sort_type"] = "DESC"; //this.direction;
    //   args["start_date"] = "2023-01-01";
    //   args["end_date"] = this.$moment().format("YYYY-MM-DD");
    //   // args["start_date"] = this.dateRange[0] != null ? (this.dateRange[0] != "" ? this.$moment(this.dateRange[0]).format("YYYY-MM-DD") : "") : "";
    //   // args["end_date"] = this.dateRange[1] != null ? (this.dateRange[1] != "" ? this.$moment(this.dateRange[1]).format("YYYY-MM-DD") : "") : "";
    //   xhr
    //     .doRequest(args, xhr.ACCOUNT.ticketList)
    //     .then(res => {
    //       this.deposit.list = res.data.ticket_list;
    //       this.deposit.totalRows = res.data.ticket_list.length > 0 ? res.data.ticket_list[0]["totalrows"] : 0;
    //       this.$root.$emit("bv::table::refresh", "depositList");

    //       args["request_type"] = "withdrawal";
    //       args["page_number"] = parseInt(this.withdrawal.currentPage);
    //       this.withdrawal.currentPage = args["page_number"];
    //       xhr
    //         .doRequest(args, xhr.ACCOUNT.ticketList)
    //         .then(res => {
    //           this.withdrawal.list = res.data.ticket_list;
    //           this.withdrawal.totalRows = res.data.ticket_list.length > 0 ? res.data.ticket_list[0]["totalrows"] : 0;
    //           this.$root.$emit("bv::table::refresh", "withdrawalList");
    //         })
    //         .catch(res => {
    //           this.$helpers.handleFeedback(res.status);
    //         });
    //     })
    //     .catch(res => {
    //       this.$helpers.handleFeedback(res.status);
    //     });
    // },
    getDepositList() {
      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username
      };
      args["request_type"] = "deposit";
      args["page_number"] = parseInt(this.deposit.currentPage);
      this.deposit.currentPage = args["page_number"];

      args["bank_id"] = this.bank_id || null;
      args["member_id"] = this.search_id || null;
      args["ticket_status"] = this.ticket_status || null;
      args["page_size"] = this.perPage;
      args["sort_key"] = "id"; // this.sortBy;
      args["sort_type"] = "DESC"; //this.direction;
      args["start_date"] = "2023-01-01";
      args["end_date"] = this.$moment().format("YYYY-MM-DD");
      // args["start_date"] = this.dateRange[0] != null ? (this.dateRange[0] != "" ? this.$moment(this.dateRange[0]).format("YYYY-MM-DD") : "") : "";
      // args["end_date"] = this.dateRange[1] != null ? (this.dateRange[1] != "" ? this.$moment(this.dateRange[1]).format("YYYY-MM-DD") : "") : "";
      this.deposit.loading = true;
      xhr
        .doRequest(args, xhr.ACCOUNT.depositTicketList)
        .then(res => {
          this.deposit.loading = false;
          this.deposit.list = res.data.ticket_list;
          this.deposit.totalRows = res.data.ticket_list.length > 0 ? res.data.ticket_list[0]["totalrows"] : 0;
          this.$root.$emit("bv::table::refresh", "depositList");
        })
        .catch(res => {
          this.deposit.loading = false;
          this.$helpers.handleFeedback(res.status);
        });
    },
    getWithdrawalList() {
      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username
      };
      args["request_type"] = "withdrawal";
      args["page_number"] = parseInt(this.withdrawal.currentPage);
      this.withdrawal.currentPage = args["page_number"];

      args["bank_id"] = this.bank_id || null;
      args["member_id"] = this.search_id || null;
      args["ticket_status"] = this.ticket_status || null;
      args["page_size"] = this.perPage;
      args["sort_key"] = "id"; // this.sortBy;
      args["sort_type"] = "DESC"; //this.direction;
      args["start_date"] = "2023-01-01";
      args["end_date"] = this.$moment().format("YYYY-MM-DD");
      // args["start_date"] = this.dateRange[0] != null ? (this.dateRange[0] != "" ? this.$moment(this.dateRange[0]).format("YYYY-MM-DD") : "") : "";
      // args["end_date"] = this.dateRange[1] != null ? (this.dateRange[1] != "" ? this.$moment(this.dateRange[1]).format("YYYY-MM-DD") : "") : "";
      this.withdrawal.loading = true;
      xhr
        .doRequest(args, xhr.ACCOUNT.withdrawalTicketList)
        .then(res => {
          this.withdrawal.loading = false;
          this.withdrawal.list = res.data.ticket_list;
          this.withdrawal.totalRows = res.data.ticket_list.length > 0 ? res.data.ticket_list[0]["totalrows"] : 0;
          this.$root.$emit("bv::table::refresh", "withdrawalList");
        })
        .catch(res => {
          this.withdrawal.loading = false;
          this.$helpers.handleFeedback(res.status);
        });
    },
    openLink(e) {
      window.open(e, "attachment", `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=600,height=300`);
    },
    updateDepositTicket(e, f) {
      this.$refs.depositTicket.item = e;
      this.$refs.depositTicket.flag = f;
      this.$refs.depositTicket.$refs.depositTicket.show();
    },
    updateWithdrawalTicket(e, f) {
      this.$refs.withdrawalTicket.item = e;
      this.$refs.withdrawalTicket.flag = f;
      var opt = [];
      for (var i = 0; i < this.withdrawalBankList.length; i++) {
        opt.push({
          value: this.withdrawalBankList[i],
          text:
            this.withdrawalBankList[i].bank_name +
            " | " +
            this.withdrawalBankList[i].bank_acc_holder +
            " | " +
            this.withdrawalBankList[i].bank_acc_no +
            " | " +
            this.$numeral(this.withdrawalBankList[i].account_balance).format("0,0.00")
        });
      }
      this.$refs.withdrawalTicket.bankList = opt;
      this.$refs.withdrawalTicket.$refs.withdrawalTicket.show();
    }
  }
};
</script>
